import * as React from 'react';
import { formatCurrency } from '../../../../utils/currency-formatter';
import { CreditHoldList } from '../../../../modules/ordering/models/credit-hold-list';

interface IProps {
    onOrderClick: any;
    order: CreditHoldList;
}

export const CreditHoldOrderRow = (props: IProps) => {

    return (
        <tr onClick={() => props.onOrderClick(props.order.dealerId, props.order.dealerName, props.order.creditHoldReason)}>
            <td>{`${props.order.dealerName} [${props.order.dealerId}]`}</td>
            <td>{formatCurrency(props.order.subtotal)}</td>
            <td>{formatCurrency(props.order.freight)}</td>
            <td>{formatCurrency(props.order.tax)}</td>
            <td>{formatCurrency(props.order.total)}</td>
        </tr>
    );
};
